import { useSyncExternalStore, useCallback } from "react";
import * as gamificationStore from "../store/gamification-store";

export function useGamification() {
  const state = useSyncExternalStore(
    gamificationStore.subscribe,
    gamificationStore.getSnapshot,
  );

  const addXp = useCallback((amount: number, reason: string) => {
    gamificationStore.addXp(amount, reason);
  }, []);

  const checkAchievements = useCallback(() => {
    gamificationStore.checkAchievements();
  }, []);

  const getNextLevelXp = useCallback(() => {
    return gamificationStore.getNextLevelXp(state.xp);
  }, [state.xp]);

  const getProgressPercent = useCallback(() => {
    return gamificationStore.getProgressPercent(state.xp);
  }, [state.xp]);

  return {
    state,
    addXp,
    checkAchievements,
    getNextLevelXp,
    getProgressPercent,
  };
}
